import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router-dom';
import ReduxFormField from 'modules/styled/form/reduxformfield.component';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, View } from 'modules/styled/web';
import { required } from 'modules/form/validators';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { resetPassword } from 'modules/auth/auth.actions';
import { hideModal, showModal } from 'modules/navigation/navigation.actions';

class ResetPassword extends Component {
  static propTypes = {
    match: PropTypes.object,
    actions: PropTypes.object,
    history: PropTypes.object,
    handleSubmit: PropTypes.func,
    auth: PropTypes.object,
    close: PropTypes.func,
    showModal: PropTypes.func,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { location } = this.props;
    const route = {
      path: '/user/resetPassword/:token',
      exact: true,
    };
    const match = matchPath(location.pathname, route);
    this.token = match && match.params && match.params.token;
  }

  submit = (vals) => {
    const { user } = this.props.auth;
    this.props.actions.resetPassword(vals.password, this.token).then((success) => {
      if (success && !user) {
        this.props.actions.showModal('login');
      } else {
        this.props.close();
      }
    });
  };

  render() {
    const { handleSubmit } = this.props;
    const FORM_FIELDS = [
      {
        name: 'password',
        component: ReduxFormField,
        type: 'password',
        label: 'Password',
        validate: [required],
      },
      {
        name: 'confirmPassword',
        component: ReduxFormField,
        type: 'password',
        label: 'Confirm Password',
        validate: [required],
      },
    ];
    return (
      <View sx={{ my: 4 }}>
        <Form sx={{ flex: 1 }} onSubmit={handleSubmit(this.submit.bind(this))}>
          {FORM_FIELDS.map((field, index) => (
            <Field {...field} key={index} />
          ))}
          <View sx={{ mt: 4, justifyContent: 'flex-end' }}>
            <Button type="submit" sx={{ p: 0 }}>
              Update Password
            </Button>
          </View>
        </Form>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      resetPassword,
      hideModal,
      showModal,
    },
    dispatch
  ),
});

export default reduxForm({
  form: 'settings',
  validate: (vals) => {
    const errors = {};
    if (vals.password !== vals.confirmPassword) {
      const message = 'Passwords must be identical';
      errors.password = message;
      errors.confirmPassword = message;
    }
    return errors;
  },
})(connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPassword)));
